import { useState } from 'react'
import type { StatusType } from './StatusCard'

export interface AvatarProps {
  src?: string
  fallback?: string
  alt?: string
  size?: 'sm' | 'md' | 'lg'
  ring?: boolean
  ringColor?: StatusType
  badge?: number | string
  className?: string
}

const sizeMap = {
  sm: 32,
  md: 48,
  lg: 64,
}

export function Avatar({
  src,
  fallback = '🐾',
  alt = '',
  size = 'md',
  ring = false,
  ringColor = 'neutral',
  badge,
  className = '',
}: AvatarProps) {
  const [imageError, setImageError] = useState(false)
  const showFallback = !src || imageError

  const sizeValue = sizeMap[size]

  return (
    <div
      className={`
        avatar
        avatar--${size}
        ${ring ? 'avatar--ring' : ''}
        ${ring ? `avatar--ring-${ringColor}` : ''}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
      style={{ width: sizeValue, height: sizeValue }}
    >
      {showFallback ? (
        <span className="avatar__fallback" aria-hidden="true">
          {fallback}
        </span>
      ) : (
        <img
          src={src}
          alt={alt}
          className="avatar__image"
          onError={() => setImageError(true)}
        />
      )}
      {badge !== undefined && (
        <span className="avatar__badge" aria-label={`${badge}`}>
          {badge}
        </span>
      )}
    </div>
  )
}
